// extracted by mini-css-extract-plugin
export default {"terminator":"_j482mo","description":"_rlkjlf","cta":"_gt3ww7","icon":"_nuofmq"};